import {
	type PartnerGeneralUpdateDto,
	patchPartnersId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PARTNER_DETAIL } from "Partner/Api/Query/usePartnerByIdQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useUpdateGeneralInfo = (partnerId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: PartnerGeneralUpdateDto) =>
			patchPartnersId(data, partnerId),
		),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerGeneralInfoUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(
				t(partnerMutationsResource.partnerGeneralInfoUpdateSuccess),
			);
			queryClient.invalidateQueries({
				queryKey: [PARTNER_DETAIL, partnerId],
			});
		},
	});
};
